<template>
    <div class="modal fade" id="filter-group" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content" style="background: #111; border: 1px solid rgba(255,255,255,0.1); border-radius: 16px;">
                <div class="modal-header border-0 pb-0">
                    <h5 class="modal-title text-white font-weight-500" id="exampleModalLabel">Broadcast Groups</h5>
                    <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" style="opacity: 0.8; outline: none;">
                         <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body pt-3 pb-4 px-4">
                    <p class="text-muted font-size-14 mb-4">Select a filter group to send an announcement, or create a new one.</p>
                    
                    <div class="contianer-fluid p-0">
                        <!-- Create New Group Button -->
                        <div class="filter-group-row d-flex align-items-center mb-3 p-3 rounded"
                             style="background: rgba(229, 59, 185, 0.1); border: 1px dashed #E53BB9; cursor: pointer;"
                             @click="$emit('create')">
                             <div class="filter-group-icon me-3 d-flex align-items-center justify-content-center rounded-circle"
                                  style="width: 40px; height: 40px; background: rgba(229, 59, 185, 0.2);">
                                 <i class="fa fa-plus" style="color: #E53BB9;"></i>
                             </div>
                             <div>
                                 <span class="text-white font-weight-500 font-size-14">Create New Filter Group</span>
                             </div>
                        </div>

                        <!-- Existing Groups -->
                        <div class="groups-list-container" style="max-height: 400px; overflow-y: auto;">
                            <div class="filter-group-row d-flex align-items-center justify-content-between p-3 mb-2 rounded"
                                 v-for="(filter, index) in filterSettings" :key="index"
                                 style="background: rgba(255, 255, 255, 0.05); cursor: pointer;"
                                 @click="$emit('edit', filter)">
                                <div class="d-flex align-items-center">
                                    <div class="filter-group-icon me-3 d-flex align-items-center justify-content-center rounded-circle"
                                         style="width: 40px; height: 40px; background: rgba(255, 255, 255, 0.05);">
                                        <i class="fa fa-users" style="color: #F3DA6B;"></i>
                                    </div>
                                    <div>
                                        <span class="text-white font-size-14 font-weight-500 d-block">{{ filter.name }}</span>
                                        <span class="text-muted font-size-12">{{ filter.customerCount }} subscribers</span>
                                    </div>
                                </div>
                                <div>
                                    <i class="fa fa-chevron-right text-muted font-size-12" style="opacity: 0.5;"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FilterModal from "@/components/module/influencer/direct-message/FilterModal";
export default {
    name: 'FilterGroup',
    components: { FilterModal },
    props: ['filterSettings'],
    beforeDestroy() {
        this.hide();
    },
    destroyed() {
        this.hide();
    },
    methods: {
        show() {
            if (window.$ && typeof window.$.fn.modal === 'function') {
                $('#filter-group').modal('show');
            } else if (window.bootstrap && window.bootstrap.Modal) {
                const el = document.getElementById('filter-group');
                if (el) {
                    const modal = window.bootstrap.Modal.getOrCreateInstance(el);
                    modal.show();
                }
            }
        },
        hide() {
            if (window.$ && typeof window.$.fn.modal === 'function') {
                $('#filter-group').modal('hide');
            } else if (window.bootstrap && window.bootstrap.Modal) {
                const el = document.getElementById('filter-group');
                if (el) {
                    const modal = window.bootstrap.Modal.getInstance(el);
                    if (modal) modal.hide();
                }
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        this.hide(); // Ensure modal is hidden when navigating away
        next(); // Proceed with the navigation
    }
}
</script>

<style scoped>
.filter-group-row {
    transition: all 0.2s ease;
}
.filter-group-row:hover {
    background: rgba(255, 255, 255, 0.08) !important;
    transform: translateY(-1px);
}
.groups-list-container::-webkit-scrollbar {
    width: 6px;
}
.groups-list-container::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.02);
    border-radius: 4px;
}
.groups-list-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}
</style>
